import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { depenses } from '../services/api';
import { useNdf } from '../NdfContext';
import { eur } from '../services/format';
import SelecteurDossier from './SelecteurDossier';
import './Fiche.css';

// Indemnités kilométriques : distance + motif, montant calculé au barème.
// Le véhicule et la puissance sont mémorisés localement — la 2e saisie prend
// dix secondes.
function FicheKm() {
  const navigate = useNavigate();
  const { refs } = useNdf();
  const [erreur, setErreur] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [f, setF] = useState(() => {
    let memo = {};
    try { memo = JSON.parse(localStorage.getItem('ndf-vehicule') || '{}'); } catch {}
    return {
      date_depense: new Date().toISOString().slice(0, 10),
      distance_km: '',
      puissance: memo.puissance || '',
      vehicule: memo.vehicule || '',
      motif_deplacement: '',
      dossier_id: null,
    };
  });

  useEffect(() => {
    if (!f.puissance && refs.bareme.length) {
      setF((x) => ({ ...x, puissance: refs.bareme[0].puissance }));
    }
  }, [refs.bareme, f.puissance]);

  const taux = parseFloat(refs.bareme.find((b) => b.puissance === f.puissance)?.taux || 0);
  const distance = parseFloat(String(f.distance_km).replace(',', '.'));
  const montant = Number.isFinite(distance) && taux ? distance * taux : null;

  const creer = async () => {
    setErreur('');
    setEnvoi(true);
    try {
      try { localStorage.setItem('ndf-vehicule', JSON.stringify({ puissance: f.puissance, vehicule: f.vehicule })); } catch {}
      await depenses.creer({
        type: 'km',
        dossier_id: f.dossier_id,
        date_depense: f.date_depense || null,
        distance_km: distance,
        puissance: f.puissance,
        vehicule: f.vehicule,
        motif_deplacement: f.motif_deplacement,
      });
      navigate('/');
    } catch (err) {
      setErreur(err.response?.data?.error || 'Création impossible');
      setEnvoi(false);
    }
  };

  return (
    <div className="fd-page">
      <button type="button" className="fd-retour" onClick={() => navigate(-1)}>← Retour</button>
      <h2 className="nf-titre-page">🚗 Indemnités kilométriques</h2>
      {erreur && <div className="nf-erreur-bandeau">{erreur}</div>}
      <div className="fd-form fd-form--etroit">
        <label className="fd-champ">
          <span>Date du déplacement</span>
          <input type="date" value={f.date_depense} onChange={(e) => setF({ ...f, date_depense: e.target.value })} />
        </label>
        <label className="fd-champ">
          <span>Distance aller-retour (km)</span>
          <input type="number" inputMode="decimal" min="1" value={f.distance_km}
            onChange={(e) => setF({ ...f, distance_km: e.target.value })} />
        </label>
        <label className="fd-champ">
          <span>Motif du déplacement</span>
          <input type="text" value={f.motif_deplacement} placeholder="ex. réunion concession Blue"
            onChange={(e) => setF({ ...f, motif_deplacement: e.target.value })} />
        </label>
        <label className="fd-champ">
          <span>Puissance fiscale</span>
          <select value={f.puissance} onChange={(e) => setF({ ...f, puissance: e.target.value })}>
            {refs.bareme.map((b) => (
              <option key={b.puissance} value={b.puissance}>{b.puissance} — {b.taux} €/km</option>
            ))}
          </select>
        </label>
        <label className="fd-champ">
          <span>Véhicule (facultatif)</span>
          <input type="text" value={f.vehicule} placeholder="ex. Peugeot 208 AB-123-CD"
            onChange={(e) => setF({ ...f, vehicule: e.target.value })} />
        </label>

        <SelecteurDossier valeur={f.dossier_id} onChange={(v) => setF({ ...f, dossier_id: v })} />

        <div className="fd-km-total">
          {montant !== null
            ? <>Montant : <strong className="nf-montant">{eur(montant)}</strong> <span className="text-muted">({distance} km × {taux} €)</span></>
            : 'Saisissez la distance pour voir le montant.'}
        </div>

        <div className="fd-actions">
          <button type="button" className="nf-btn nf-btn--principal fd-enregistrer" onClick={creer}
            disabled={envoi || montant === null || !f.motif_deplacement.trim()}>
            {envoi ? 'Ajout…' : 'Ajouter à mes dépenses'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FicheKm;
